export default __webpack_public_path__ + "static/app-conversion-143816ce146962edfc0157245d091241.jpg";